import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { credentialsLoginPath, rootPath } from '~/common/paths'
import { Button } from '~/ui/button'
import { useToast } from '~/hooks/use-toast'

export const EmailLoginScreen: React.FC = () => {
  const { toast } = useToast()
  const navigate = useNavigate()
  const handleRedirectToCredentials = () => {
    toast({
      title: 'Email login flow updated',
      description: 'Please log in with your email and password instead.',
      variant: 'default',
    })
    navigate(credentialsLoginPath({}))
  }

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center">
      <div className="w-full max-w-md space-y-8">
        <h1 className="text-center text-2xl font-bold">Login with Email</h1>
        <div className="space-y-6">
          <p className="text-center">
            The magic-link email login flow has been replaced. Please log in with your email and
            password instead.
          </p>
          <Button onClick={handleRedirectToCredentials} className="w-full">
            Go to email & password login
          </Button>
          <Button variant="outline" onClick={() => navigate(rootPath({}))} className="w-full">
            Return to Home
          </Button>
        </div>
        <div className="space-y-2 text-center">
          <Link
            to={credentialsLoginPath({})}
            className="block text-sm text-blue-600 hover:underline"
          >
            Login with username and password
          </Link>
        </div>
      </div>
    </div>
  )
}
